import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Link } from "gatsby";

import "./not-found-page.css"

const NotFoundPage = ({ data }) => {
    let contentData = data.contentfulPage
    return (
        <div className="relative not-found">
            <GatsbyImage
                image={getImage(contentData.pageMediaList[0])}
                alt={`${contentData.pageTitle} thumbnail`}
                className="not-found-bg"
            />
            <div className="container-custom custom-padding text-white text-center">
                <h1>Page Not Found!</h1>
                <p className="bold">The page you are looking for does not exist.</p>
                <Link href="/" className="btn btn-brand-color-linear ibp-btn-link">Go Back to Homepage</Link>
            </div>
        </div>
    )
};

export default NotFoundPage
